<template>
  <div>
    <div style="min-height: 200px;" v-if="isLoading">
      <b-loading :is-full-page="false" :active="isLoading" :can-cancel="false"></b-loading>
    </div>

  <div :style="{height: (this.labels.length * 70) + 'px'}" v-else>
    <horizontal-bar-chart slot="content"  class="chart-height" v-if="!isLoading"
        :chart-data="defaultChart.chartData"
                      :extra-options="defaultChart.extraOptions"
        ></horizontal-bar-chart>
  </div>
  </div>
</template>

<script>
import * as chartConfig from '@/components/Charts/chart.config'
import HorizontalBarChart from '@/components/Charts/HorizontalBarChart'

import ExecutionService from '@/services/ExecutionService.js'
export default {
  components: {
    HorizontalBarChart
  },
  props: {
    eventId: {
      required: true
    }
  },
  created () {
    this.getExecutions()
  },
  data () {
    return {
      defaultChart: {
        chartData: {},
        extraOptions: {
          ...chartConfig.chartOptionsMain,
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              title: function (tooltipItem, data) {
                return tooltipItem[0].yLabel[2]
              },
              afterLabel: function (tooltipItem, data) {
                return `Puesto: ${tooltipItem.index + 1}`
              },
              label: function (tooltipItem, data) {
                return `Nota: ${tooltipItem.value}`
              }
            }
          }
        }
      },
      isLoading: false,
      labels: [],
      scores: []
    }
  },
  methods: {
    async getExecutions () {
      this.isLoading = true
      let response = await ExecutionService.getExecutions(this.eventId)
      let executions = response.data.data

      executions = executions.sort((a, b) => {
        if (a.result_execution && b.result_execution) {
          if (a.result_execution.final_score > b.result_execution.final_score) {
            return -1
          }
          if (a.result_execution.final_score < b.result_execution.final_score) {
            return 1
          }
        } else if (a.result_execution && !b.result_execution) {
          return -1
        } else if (!a.result_execution && b.result_execution) {
          return 1
        }
        return 0
      })
      this.labels = executions.map((execution) => {
        let rider = `${execution.rider.lastname} ${execution.rider.name}`
        let horse = `${execution.horse.name}`
        let lesson = `${execution.lesson.name}`
        return [horse, rider, lesson]
      })

      this.scores = executions.map((execution) => {
        return execution.result_execution ? execution.result_execution.final_score : 0
      })
      this.fillChartData()
      this.isLoading = false
    },
    randomChartData (n) {
      let data = []
      for (let i = 0; i < n; i++) {
        data.push(Math.round(Math.random() * 200))
      }
      return data
    },
    fillChartData () {
      this.defaultChart.chartData = {
        datasets: [
          {
            barThickness: 10,
            maxBarThickness: 10,
            backgroundColor: chartConfig.chartColors.default.primary,
            data: this.scores,
            label: 'Nota Promedio'
          }
        ],
        labels: this.labels
      }
    }
  }

}
</script>

<style scoped>
  .chart-height{
    height: 100%;
  }
</style>
